import React, { useContext } from 'react';
import { WarehouseIndexContext, useActionsWarehouseIndex, useDispatchWarehouseIndex, useWarehouse } from '../../../../context/inventory/WarehouseIndexProvider';
import { LineTitle } from '../../article';
import { CreateWarehouse } from '../form/CreateWarehouse';
import '../form/CreateWarehouse.css';
import Moment from 'react-moment';
import { FORMAT_DATE_TIME_MOMENT } from '../../../../api/constant';
import Pagination from '../../../app/atoms/Pagination';
import { types } from '../../../../reducers/inventory/warehouseReducer';

export const WarehouseIndex = () => {

  const state = useWarehouse();
  const dispatch = useDispatchWarehouseIndex();
  const action =useActionsWarehouseIndex();

  const [{ listWarehousesState }, { goToWarehouseEdit }] = useContext(WarehouseIndexContext);
  return (
    <div className="container-fluid">
      <LineTitle title={"Lista de almacenes"} />

      <CreateWarehouse />

      <LineTitle />

      <table className="table table-warehouse">
        <thead className="thead-dark thead-warehouse">
          <tr>
            <th scope="col">ID de creación</th>


            <th scope="col">Fecha creación</th>

            <th scope="col">Código de almacén</th>
            <th scope="col">Nombre de almacén</th>
            <th scope="col">Última modificación</th>
          </tr>
        </thead>
        <tbody>
          {state.elements.map((item) => {
            return (
              <tr key={item.id} className="cursor-pointer td-hoverme" onClick={() => action.goToWarehouseEdit(item.id)} >
                <td>
                  <span className="cursor-pointer">{item.id}</span>
                </td>
                <td>
                  <Moment format={FORMAT_DATE_TIME_MOMENT}>
                    {item.created_at}
                  </Moment>
                </td>
                <td>{item.code}</td>

                <td>{item.name}</td>

                <td>
                  <Moment format={FORMAT_DATE_TIME_MOMENT}>
                    {item.updated_at}
                  </Moment>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <div className="flex justify-end">
        <Pagination
          onChangepage={(e) =>
            dispatch({
              type: types.CHANGE_INPUT_FILTER_WAREHOUSES,
              payload: { name: "page", value: e },
            })
          }
          page={state.filter.page}
          limit={state.filter.limit}
          rows={state.rows}
        />
      </div>

    </div>
  )
}
